// @ts-nocheck
import * as Types from '../../../__generated__/graphqlTypes';

import { gql } from '@apollo/client';
export type InsideMapsIframeData_CheckoutConfigFragment = { __typename?: 'CheckoutConfig', id: string, insideMapsTextureSwaps?: { __typename?: 'InsideMapsTextureSwaps', projectId?: string | null | undefined, cameras: Array<{ __typename?: 'InsideMapsCamera', cameraName: string, displayName: string, locationId?: string | null | undefined, alternateCameras: Array<{ __typename?: 'InsideMapsCamera', cameraName: string, displayName: string, locationId?: string | null | undefined }> }>, textureSwapsByCamera: Array<{ __typename?: 'InsideMapsCameraTextureSwaps', cameraName: string, textureSwaps: Array<{ __typename?: 'InsideMapsTextureSwap', part: string, texture: string }> }>, debugSlots?: Array<{ __typename?: 'InsideMapsDebugSlot', message: string }> | null | undefined } | null | undefined };

export type InsideMapsTextureSwaps_InsideMapsTextureSwapsFragment = { __typename?: 'InsideMapsTextureSwaps', projectId?: string | null | undefined, cameras: Array<{ __typename?: 'InsideMapsCamera', cameraName: string, displayName: string, locationId?: string | null | undefined, alternateCameras: Array<{ __typename?: 'InsideMapsCamera', cameraName: string, displayName: string, locationId?: string | null | undefined }> }>, textureSwapsByCamera: Array<{ __typename?: 'InsideMapsCameraTextureSwaps', cameraName: string, textureSwaps: Array<{ __typename?: 'InsideMapsTextureSwap', part: string, texture: string }> }>, debugSlots?: Array<{ __typename?: 'InsideMapsDebugSlot', message: string }> | null | undefined };

export type InsideMapsCamera_InsideMapsCameraFragment = { __typename?: 'InsideMapsCamera', cameraName: string, displayName: string, locationId?: string | null | undefined, alternateCameras: Array<{ __typename?: 'InsideMapsCamera', cameraName: string, displayName: string, locationId?: string | null | undefined }> };

export const InsideMapsCamera_InsideMapsCameraFragmentDoc = gql`
    fragment InsideMapsCamera_InsideMapsCamera on InsideMapsCamera {
  cameraName
  displayName
  locationId
  alternateCameras {
    cameraName
    displayName
    locationId
  }
}
    `;
export const InsideMapsTextureSwaps_InsideMapsTextureSwapsFragmentDoc = gql`
    fragment InsideMapsTextureSwaps_InsideMapsTextureSwaps on InsideMapsTextureSwaps {
  projectId
  cameras {
    ...InsideMapsCamera_InsideMapsCamera
  }
  textureSwapsByCamera {
    cameraName
    textureSwaps {
      part
      texture
    }
  }
  debugSlots {
    message
  }
}
    ${InsideMapsCamera_InsideMapsCameraFragmentDoc}`;
export const InsideMapsIframeData_CheckoutConfigFragmentDoc = gql`
    fragment InsideMapsIframeData_CheckoutConfig on CheckoutConfig {
  id
  insideMapsTextureSwaps(debugParts: $debugParts) {
    ...InsideMapsTextureSwaps_InsideMapsTextureSwaps
  }
}
    ${InsideMapsTextureSwaps_InsideMapsTextureSwapsFragmentDoc}`;